import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ErrorBoundaryIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3.60156"
        y="3.10156"
        width="41.8"
        height="41.8"
        rx="20.9"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        d="M30.4779 18.0273L18.5312 29.974M30.4779 29.974L18.5313 18.0273"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

ErrorBoundaryIcon.displayName = 'ErrorBoundaryIcon';
